import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React, { useRef } from 'react';
import { generateUUID } from '../helpers/utility';
import { config } from '../helpers/config';

var Checkbox = function Checkbox(_ref) {
  var _cx;

  var className = _ref.className,
      disabled = _ref.disabled,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value,
      opts = _objectWithoutPropertiesLoose(_ref, ["className", "disabled", "label", "name", "onChange", "value"]);

  var checkboxLabelRef = useRef();
  var id = name + "-" + generateUUID();

  var toggleChecked = function toggleChecked(_ref2) {
    var _ref2$target = _ref2.target,
        fieldName = _ref2$target.name,
        fieldValue = _ref2$target.value,
        checked = _ref2$target.checked;
    onChange(fieldName, fieldValue, checked);
  };

  var classes = cx('form-checkbox', className, (_cx = {}, _cx[config.classes.disabled] = disabled, _cx));
  return React.createElement("div", {
    className: classes
  }, React.createElement("input", Object.assign({
    value: value,
    type: "checkbox",
    disabled: disabled,
    name: name,
    id: id,
    onChange: toggleChecked
  }, opts)), label && React.createElement("label", {
    // eslint-disable-line jsx-a11y/label-has-for
    htmlFor: id,
    ref: checkboxLabelRef
  }, label));
};

export default Checkbox;